import { render, staticRenderFns } from "./VerPacientesEnEspera.vue?vue&type=template&id=dcb12efe&scoped=true"
import script from "./VerPacientesEnEspera.vue?vue&type=script&lang=js"
export * from "./VerPacientesEnEspera.vue?vue&type=script&lang=js"
import style0 from "./VerPacientesEnEspera.vue?vue&type=style&index=0&id=dcb12efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb12efe",
  null
  
)

export default component.exports